/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import RegularFeatures from './RegularFeatures';
import CustomFeatures from './CustomFeatures';
import { useTranslationsContext } from '../../../context/TranslationsContext';

import { Heading } from '../css';

const Features = ({
  formFields,
  selectedFeatures,
  setSelectedFeatures,
  showOnlyCategories = [],
  regularFeatures = true,
  customFeatures = true
}) => {
  const {
    WLS: {
      WIRELESS_ORDER_DETAILS: {
        Features: { Features }
      }
    }
  } = useTranslationsContext();

  return (
    <div style={{ marginTop: '2rem' }}>
      <div style={{ margin: '1rem 0' }}>
        <Heading level="h4">{Features}</Heading>
      </div>

      {regularFeatures && (
        <RegularFeatures
          formFields={formFields}
          selectedFeatures={selectedFeatures}
          setSelectedFeatures={setSelectedFeatures}
          showOnlyCategories={showOnlyCategories}
        />
      )}
      {customFeatures && (
        <CustomFeatures
          selectedFeatures={selectedFeatures}
          setSelectedFeatures={setSelectedFeatures}
          showOnlyCategories={showOnlyCategories}
        />
      )}
    </div>
  );
};

Features.propTypes = {
  formFields: PropTypes.arrayOf(PropTypes.any).isRequired,
  selectedFeatures: PropTypes.arrayOf(PropTypes.any).isRequired,
  setSelectedFeatures: PropTypes.func.isRequired,
  showOnlyCategories: PropTypes.array,
  regularFeatures: PropTypes.bool,
  customFeatures: PropTypes.bool
};

export default Features;
